import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import SendIcon from "@material-ui/icons/Send";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { objectToFormData } from "object-to-formdata";

import axios from "axios";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  dialog: {
    "& .MuiDialog-paper": {
      maxWidth: "700px",
    },
  },
  tooltip: {
    fontSize: "14px",
    fontWeight: "normal",
  },
}));

export default function ActaFinalModal(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [openSpinner, setOpenSpinner] = React.useState(false);
  const [attachment, setAttachment] = React.useState(null);

  const handleOpen = (event) => {
    setOpen(!open);
  };

  const handleClick = () => {
    setOpenSpinner(true);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    var formObj = {
      archivos: [{nombre: "acta", archivo: attachment}],
    };
    const formData = objectToFormData(formObj);
    axios
      .post(
        window.ENV.API_URL + "/concursosActa/" + props.concursoId + "/",
        formData,
        config
      )
      .then((res) => {
        handleOpen();
        setOpenSpinner(false);
      })
      .then((res) => window.location.href = window.ENV.URL_FRONT + "Concursos?tab=4")
      .catch((error) => console.error(error));
  };

  const onChangeSelectedFiles = (event) => {
    const files = event.target.files;
    if (files.length === 0) {
      // no files selected --> do nothing
    } else if (files.length === 1) {
      const archivo = files.item(0);
      setAttachment(archivo);
    } else {
      alert("Seleccione solo un archivo a la vez");
    }
  };

  return (
    <Fragment>
      {/*<Button startIcon={<SendIcon />} color="primary" onClick={handleOpen}>
        {props.label}
      </Button>*/}
      
      <Tooltip
        onClick={handleOpen}
        title={<span className={classes.tooltip}>{props.label}</span>}
      >
        <IconButton>
          <SendIcon />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleOpen}
        scroll={"paper"}
        className={classes.dialog}
        fullWidth
      >
        <DialogTitle>Acta de cierre</DialogTitle>
        <DialogContent dividers={true}>
          <p className="text-center">
            Escoja el acta de cierre del concurso{" "}
            <strong>{`${props.code} - ${props.name}`}</strong>
            (.pdf)
          </p>
          <div className="d-flex justify-content-center">
            <input type="file" accept=".pdf" onChange={onChangeSelectedFiles} />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            disableElevation
            style={{ marginRight: "1em" }}
            variant="contained"
            onClick={handleOpen}
          >
            Cancelar
          </Button>
          <Button
            disableElevation
            color="primary"
            variant="contained"
            onClick={handleClick}
          >
            Finalizar
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={openSpinner}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </Fragment>
  );
}
